var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 270 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.125 84.5443L130.7 85.1019C134.417 85.4736 138.412 86.4028 138.412 93.8365V103.407H133.58V89.7479L128.005 88.9116C127.076 88.8187 126.054 88.6329 125.125 88.3541V103.407H120.293V88.2612H125.032C122.43 87.4249 120.293 85.5665 120.293 80.1771V77.5753H125.125V84.5443Z",
    fill: "#AAAAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.868 99.04H110.629V85.009H115.368V103.407H109.049C103.102 103.407 100.036 100.898 100.036 94.6727V85.009H104.868V99.04Z",
    fill: "#AAAAB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6287 85.009H94.3677V99.04H100.593V103.407H98.6421C92.6951 103.407 89.6287 100.898 89.6287 94.6727V85.009Z",
    fill: "#AAAAB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.846 85.009H175.86C181.806 85.009 184.873 87.4249 184.873 93.7435V96.0666H175.86C174.17 96.0666 172.713 95.864 171.492 95.4312V99.04H183.851V103.407H175.767C169.82 103.407 166.753 100.991 166.753 95.4161H171.45C168.403 94.3173 166.846 91.7683 166.846 87.332V85.009ZM180.041 92.071V89.0975H171.585V92.071H180.041Z",
    fill: "#AAAAB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.965 80.0841C142.965 78.5974 143.988 77.5753 145.474 77.5753C146.961 77.5753 147.983 78.5974 147.983 80.0841C147.983 81.5709 146.961 82.593 145.474 82.593C143.988 82.593 142.965 81.5709 142.965 80.0841Z",
    fill: "#AAAAB6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.89 85.009V103.407H143.058V85.009H147.89Z",
    fill: "#AAAAB6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.258 88.8187H157.089V99.04H163.222V103.407H161.271C155.324 103.407 152.258 100.898 152.258 94.6727V88.8187Z",
    fill: "#AAAAB6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.258 80.6417H157.089V85.009H163.222V89.3762H161.271C155.324 89.3762 152.258 86.8674 152.258 80.6417Z",
    fill: "#AAAAB6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2834 80.1771C65.2834 75.7168 68.9073 72.0929 73.3675 72.0929L83.2172 72L75.133 80.0841V108.89H60.2657C52.2745 108.89 45.6771 102.385 45.6771 94.3011V88.2612H37.5C37.5 83.801 41.1239 80.1771 45.5841 80.1771H45.6771C45.6771 75.7168 49.301 72.0929 53.7612 72.0929H63.6108L55.5267 80.1771H65.2834ZM64.9117 89.0975C63.7038 90.3055 63.7038 92.2568 64.9117 93.4648C66.1197 94.6727 68.071 94.6727 69.279 93.4648L64.9117 89.0975Z",
    fill: "#AAAAB6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.514 84.5443L199.09 85.1019C202.807 85.4736 206.802 86.4028 206.709 93.8365V94.6727C206.709 100.898 203.643 103.407 197.696 103.407C191.749 103.407 188.683 100.898 188.683 94.6727V88.2612H193.422C190.82 87.4249 188.683 85.5665 188.683 80.1771V77.5753H193.514V84.5443ZM193.514 99.04H201.97V89.7479L196.395 88.9116C195.466 88.8187 194.444 88.6329 193.514 88.3541V99.04Z",
    fill: "#AAAAB6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.891 80.0841C210.891 78.5974 211.913 77.5753 213.4 77.5753C214.979 77.5753 216.001 78.5974 215.908 80.0841C215.908 81.5709 214.886 82.593 213.4 82.593C211.913 82.593 210.891 81.5709 210.891 80.0841Z",
    fill: "#AAAAB6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M225.015 80.6417V85.009H231.24V89.3762H229.289C223.342 89.3762 220.276 86.8674 220.276 80.6417H225.015Z",
    fill: "#AAAAB6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M220.276 88.8187H225.015V99.04H231.24V103.407H229.289C223.342 103.407 220.276 100.898 220.276 94.6727V88.8187Z",
    fill: "#AAAAB6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M215.908 103.407H211.077V85.009H215.908V103.407Z",
    fill: "#AAAAB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitebit);
export default __webpack_public_path__ + "static/media/whitebit.28937798d8a81c86ffc311e86a73e806.svg";
export { ForwardRef as ReactComponent };